export { default as PrintFabricNumber } from './page'


// WEBPACK FOOTER //
// ./src/pages/printFabricNumber/index.js